import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ShipCoordinatesService {
  OBPortalSvcURL = '';
  private readonly CACHE_TTL_MS = 5 * 60 * 1000;
  private cache = new Map<number | undefined, { obs: Observable<any>; ts: number }>();

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public getShipCoordinates(shpid: number | undefined): Observable<any> {
    const cached = this.cache.get(shpid);
    if (cached && (Date.now() - cached.ts) < this.CACHE_TTL_MS) {
      return cached.obs;
    }

    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const shipCoordinates: JSON = <JSON>(<unknown>{
      shpId: shpid,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const obs = this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetShipCoordinates',
      JSON.stringify(shipCoordinates),
      { headers: headers }
    ).pipe(shareReplay(1));

    this.cache.set(shpid, { obs, ts: Date.now() });
    return obs;
  }
}
